import * as questionAPI from './question';
import * as userAPI from './user';
import * as schoolAPI from './school';
import * as curiosityAPI from './curiosity';
import * as sessionAPI from './session';
import * as dashboardAPI from './dashboard';
import * as researchAPI from './research';
import * as RankingAPI from './ranking';
import * as coursesAPI from './courses';
import * as citiesAPI from './city';
import * as notificationsAPI from './notifications';
import * as missionsAPI from './missions';

export const curiosity = curiosityAPI;
export const question = questionAPI;
export const user = userAPI;
export const school = schoolAPI;
export const session = sessionAPI;
export const dashboard = dashboardAPI;
export const research = researchAPI;
export const ranking = RankingAPI;
export const courses = coursesAPI;
export const cities = citiesAPI;
export const notifications = notificationsAPI;
export const missions = missionsAPI;



// WEBPACK FOOTER //
// ./src/controllers/index.js